const NAME = "FAMILY_GROUP";

export default NAME;
